import { render } from "./DocSiderbar.vue?vue&type=template&id=0b96cc79&bindings={\"menuConfig\":\"setup\"}"
import script from "./DocSiderbar.vue?vue&type=script&lang=ts"
export * from "./DocSiderbar.vue?vue&type=script&lang=ts"
script.render = render

export default script